import { CssBaseline, ThemeProvider } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/pt-br";
import { FC } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes } from "./app/routes/routes";
import { translate } from "./app/translate/translate";
import Theme from "./assets/theme/theme";

const App: FC<any> = () => {
    const language = translate.language == "pt" ? "pt-BR" : translate.language;
    dayjs.locale(language);
    return (
        <ThemeProvider theme={Theme.theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}>
                    <CssBaseline />
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <Routes />
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default App;
